var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"v-inpage-links"},[_c('v-text',{attrs:{"size":"xsmall","heading":"","tag":"h4"}},[_vm._v(_vm._s(_vm.label))]),_c('ul',_vm._l((_vm.page),function(titleAnchor){return _c('li',{key:titleAnchor.id},[_c('a',{attrs:{"href":`#${titleAnchor.id}`}},[_vm._v(_vm._s(titleAnchor.name))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }